import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import { Table, Button, Modal } from "react-bootstrap";
import { FaNewspaper, FaRegArrowAltCircleLeft, FaChevronDown, FaEyeDropper, FaEye } from "react-icons/fa";
import Navbar from "../../dashboard/navbar";
import Sidebar from "../../dashboard/sidebar";
import useAuth from "../../dashboard/useAuth";

const Historique_evaluation = () => {
    useAuth();

    const location = useLocation();
    const { etape_id, parcours_id } = location.state || {};
    const user_id = localStorage.getItem("user_id");
    const navigate = useNavigate();

    const [evaluations, setEvaluations] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [selectedEvaluation, setSelectedEvaluation] = useState(null); // Stocke l'évaluation sélectionnée
    const [showModal, setShowModal] = useState(false);

    useEffect(() => {
        if (user_id) {
            document.title = "eTrainApp | Historique";
        }
    }, [user_id]);

        const renderCorrespondanceResultat = (qcm) => {
        try {
            let leftOptions = [];
            let rightOptions = [];

            // --- PARSER option1 ---
            if (typeof qcm.option1 === 'string') {
                try {
                    let option1Str = qcm.option1;
                    if (option1Str.startsWith('"') && option1Str.endsWith('"')) {
                        option1Str = option1Str.slice(1, -1);
                    }
                    option1Str = option1Str.replace(/""/g, '"');
                    leftOptions = JSON.parse(option1Str);
                    if (!Array.isArray(leftOptions)) leftOptions = [];
                } catch (e) {
                    console.error('Erreur parsing option1:', e);
                    leftOptions = [];
                }
            } else if (Array.isArray(qcm.option1)) {
                leftOptions = qcm.option1;
            }

            // --- PARSER option2 ---
            if (typeof qcm.option2 === 'string') {
                try {
                    let option2Str = qcm.option2;
                    if (option2Str.startsWith('"') && option2Str.endsWith('"')) {
                        option2Str = option2Str.slice(1, -1);
                    }
                    option2Str = option2Str.replace(/""/g, '"');
                    rightOptions = JSON.parse(option2Str);
                    if (!Array.isArray(rightOptions)) rightOptions = [];
                } catch (e) {
                    console.error('Erreur parsing option2:', e);
                    try {
                        const regex = /{"id":\s*(\d+),\s*"value":\s*"([^"]*)"}/g;
                        let match;
                        const extracted = [];
                        let tempStr = qcm.option2;
                        tempStr = tempStr.replace(/""/g, '"');
                        while ((match = regex.exec(tempStr)) !== null) {
                            extracted.push({
                                id: parseInt(match[1]),
                                value: match[2]
                            });
                        }
                        if (extracted.length > 0) {
                            rightOptions = extracted;
                        }
                    } catch (e2) {
                        console.error('Erreur extraction regex:', e2);
                        rightOptions = [];
                    }
                }
            } else if (Array.isArray(qcm.option2)) {
                rightOptions = qcm.option2;
            }

            // --- PARSER reponseCorrecte ---
            let reponseCorrecte = {};
            if (Array.isArray(qcm.reponse)) {
                try {
                    let fullStr = qcm.reponse.join('');
                    fullStr = fullStr.replace(/""/g, '"');
                    fullStr = fullStr.replace(/^["']|["']$/g, '');
                    const regex = /"(\d+)":\s*(\d+)/g;
                    let match;
                    while ((match = regex.exec(fullStr)) !== null) {
                        reponseCorrecte[parseInt(match[1])] = parseInt(match[2]);
                    }
                } catch (e) {
                    console.error('Erreur parsing reponse (tableau):', e);
                }
            } else if (typeof qcm.reponse === 'string') {
                try {
                    let cleanStr = qcm.reponse;
                    cleanStr = cleanStr.replace(/""/g, '"');
                    cleanStr = cleanStr.replace(/^["']|["']$/g, '');
                    const parsed = JSON.parse(cleanStr);
                    if (typeof parsed === 'object' && !Array.isArray(parsed)) {
                        reponseCorrecte = parsed;
                    }
                } catch (e) {
                    console.error('Erreur parsing reponse (string):', e);
                    try {
                        const regex = /"(\d+)":\s*(\d+)/g;
                        let match;
                        let cleanStr = qcm.reponse.replace(/""/g, '"');
                        while ((match = regex.exec(cleanStr)) !== null) {
                            reponseCorrecte[parseInt(match[1])] = parseInt(match[2]);
                        }
                    } catch (e2) {
                        console.error('Erreur parsing reponse (string regex):', e2);
                    }
                }
            } else if (typeof qcm.reponse === 'object' && !Array.isArray(qcm.reponse)) {
                reponseCorrecte = qcm.reponse;
            }

            // --- Récupérer reponseUtilisateur ---
            const reponseUtilisateur = qcm.resultat || {};

            if (leftOptions.length === 0 || rightOptions.length === 0) {
                return <div className="text-danger">
                    <p>Données de correspondance manquantes</p>
                    <p className="small">leftOptions: {leftOptions.length}, rightOptions: {rightOptions.length}</p>
                </div>;
            }

            // Vérifier si la correspondance est correcte (toutes les paires)
            const isCorrect = (() => {
                if (Object.keys(reponseUtilisateur).length === 0) return false;
                for (const key of Object.keys(reponseCorrecte)) {
                    if (!(key in reponseUtilisateur) || reponseUtilisateur[key] !== reponseCorrecte[key]) {
                        return false;
                    }
                }
                return true;
            })();

            return (
                <div style={{ margin: '10px 10px' }}>
                    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                        <thead>
                            <tr>
                                <th style={{ textAlign: 'left', padding: '5px', borderBottom: '2px solid #dee2e6' }}>Items</th>
                                <th style={{ textAlign: 'left', padding: '5px', borderBottom: '2px solid #dee2e6' }}>Réponse donnée</th>
                                <th style={{ textAlign: 'left', padding: '5px', borderBottom: '2px solid #dee2e6' }}>Statut</th>
                            </tr>
                        </thead>
                        <tbody>
                            {leftOptions.map((leftItem) => {
                                const leftId = leftItem.id;
                                const userPair = reponseUtilisateur[leftId];
                                const correctPair = reponseCorrecte[leftId];

                                let userValue = 'Non sélectionné';
                                if (userPair) {
                                    const found = rightOptions.find(r => r.id === userPair);
                                    userValue = found ? found.value : 'Non sélectionné';
                                }

                                const isItemCorrect = userPair && userPair === correctPair;

                                return (
                                    <tr key={leftId} style={{ borderBottom: '1px solid #e9ecef' }}>
                                        <td style={{ padding: '8px 5px', verticalAlign: 'middle' }}>
                                            <span style={{ fontWeight: '500' }}>{leftItem.value || `Item ${leftId}`}</span>
                                        </td>
                                        <td style={{ padding: '8px 5px', verticalAlign: 'middle' }}>
                                            <span>{userValue}</span>
                                        </td>
                                        <td style={{ padding: '8px 5px', verticalAlign: 'middle' }}>
                                            {userPair ? (
                                                isItemCorrect ? (
                                                    <i className="fa fa-thumbs-up" style={{ color: 'green', fontSize: '20px' }} title="Correct"></i>
                                                ) : (
                                                    <i className="fa fa-thumbs-down" style={{ color: 'red', fontSize: '20px' }} title="Incorrect"></i>
                                                )
                                            ) : (
                                                <i className="fa fa-minus-circle" style={{ color: 'orange', fontSize: '20px' }} title="Non répondu"></i>
                                            )}
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>

                    {/* Badge de résultat global */}
                    <div style={{ 
                        marginTop: '10px',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                        flexWrap: 'wrap',
                        justifyContent: 'right'
                    }}>
                        <span style={{ 
                            padding: '2px 10px',
                            borderRadius: '4px',
                            fontWeight: 'bold',
                            fontSize: '12px',
                            backgroundColor: isCorrect ? '#28a745' : '#dc3545',
                            color: 'white',
                            display: 'inline-block',
                            marginLeft: '5px'
                        }}>
                            {isCorrect ? '✅ Correct' : '❌ Incorrect'}
                        </span>
                    </div>

                    {/* Explication */}
                    {qcm.explication && qcm.explication !== 'non défini' && (
                        <div style={{ color: 'green', marginTop: '5px', fontSize: '13px' }}>
                            <strong>Explication :</strong>{' '}
                            <span dangerouslySetInnerHTML={{ __html: qcm.explication }} />
                        </div>
                    )}
                </div>
            );
        } catch (e) {
            console.error('Erreur rendu correspondance:', e);
            return <div className="text-danger">Erreur d'affichage des correspondances: {e.message}</div>;
        }
    };

    useEffect(() => {
        const fetchEvaluations = async () => {
            try {
                const url = new URL(
                    process.env.REACT_APP_HOTE +
                    `/historique/${user_id}/${etape_id}/${parcours_id}/${user_id}/`
                );

                const response = await fetch(url, {
                    method: "GET",
                    headers: { "Content-Type": "application/json" },
                });

                const data = await response.json();
                if (response.ok) {
                    // Filtrer les évaluations pour inclure uniquement celles avec des QCM où `reponse` n'est pas vide
                    const filteredEvaluations = (data.qcms || []).map((evaluation) => {
                        return {
                            ...evaluation,
                            qcm: evaluation.qcm.filter((qcm) => {
                                // Vérifier si resultat existe et n'est pas vide
                                if (!qcm.resultat) return false;

                                // Si c'est un objet, vérifier s'il a des clés
                                if (typeof qcm.resultat === 'object' && !Array.isArray(qcm.resultat)) {
                                    return Object.keys(qcm.resultat).length > 0;
                                }

                                // Si c'est un tableau, vérifier sa longueur
                                if (Array.isArray(qcm.resultat)) {
                                    return qcm.resultat.length > 0;
                                }

                                return false;
                            })
                        };
                    }).filter((evaluation) => evaluation.qcm.length > 0);

                    setEvaluations(filteredEvaluations);
                } else {
                    console.error(
                        "Erreur lors de la récupération des évaluations : ",
                        data
                    );
                }
            } catch (error) {
                console.error("Erreur réseau :", error);
            } finally {
                setIsLoading(false);
            }
        };

        fetchEvaluations();
    }, [user_id, etape_id, parcours_id]);


    const openModal = () => {
        if (selectedEvaluation) {
            setShowModal(true);
        }
    };

    const closeModal = () => {
        setShowModal(false);
    };

    const handleRowClick = (evaluation) => {
        setSelectedEvaluation(evaluation); // Met à jour l'évaluation sélectionnée
    };

    return (
        <div id="wrapper">
            <Sidebar user_id={user_id} />
            <div id="page-wrapper" className="gray-bg">
                <Navbar />
                <div>
                    <div className="row wrapper border-bottom white-bg page-heading">
                        <div className="col-lg-12">
                            <h2>
                                <FaNewspaper size={25} className="mr-2" />
                                Historique des évaluations
                            </h2>
                            <small id="hbreadcrumb" className="d-flex justify-content-end">
                                <ol className="breadcrumb custom-breadcrumb">
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        <Link to={`/Parcours`}>Parcours</Link>
                                    </li>
                                </ol>
                            </small>
                        </div>
                    </div>

                    <div className="container mt-3 wrapper wrapper-content animated fadeInRight">
                        <div className="row d-flex justify-content-center">
                            <div className="col-lg-8 mx-auto">
                                <div className="ibox">
                                    <div className="ibox-title pr-3 d-flex justify-content-between">
                                        <h5>Historique</h5>
                                        {/* <button
                                            onClick={openModal}
                                            className={`btn mb-2 mb-md-0 ms-0 ms-md-2 ${selectedEvaluation ? 'btn-success' : 'btn-default text-dark'}`}
                                            disabled={!selectedEvaluation}
                                        >
                                            Voir détails <FaChevronDown />
                                        </button> */}
                                    </div>

                                    <div className="ibox-content">
                                        {isLoading ? (
                                            <div>Chargement des évaluations...</div>
                                        ) : evaluations.length === 0 ? (
                                            <div>Aucune évaluation trouvée.</div>
                                        ) : (
                                            <table className="footable table table-stripped footable-loaded tablet breakpoint" data-page-size="8" data-filter="#filter">
                                                <thead>
                                                    <tr>
                                                        {/* <th>#</th> */}
                                                        <th>Évaluation</th>
                                                        <th>Nbre de questions traités</th>
                                                        <th>Date</th>
                                                        <th>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {evaluations.map((evaluation, index) => (
                                                        <tr
                                                            key={evaluation.evaluation_id}
                                                            onClick={() => handleRowClick(evaluation)}
                                                            className={`bg-white ${selectedEvaluation === evaluation ? 'bg-success text-white' : ''}`}
                                                            style={{ cursor: 'pointer' }}
                                                        >
                                                            {/* <td>{index + 1}</td> */}
                                                            <td>Évaluation N° <span className="badge badge-default">{evaluation.evaluation_id}</span></td>
                                                            <td>{evaluation.qcm.length}</td>
                                                            <td>{evaluation.date_heure}</td>
                                                            <td>
                                                                <Button
                                                                    size="sm"
                                                                    variant="info"
                                                                    onClick={() => {
                                                                        setSelectedEvaluation(evaluation);
                                                                        setShowModal(true);
                                                                    }}
                                                                >
                                                                    <FaEye />
                                                                </Button>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        )}

                                        <div className="d-flex justify-content-end mb-3">
                                            <Button
                                                className="btn btn-success d-flex align-items-center"
                                                onClick={() => navigate("/Parcours")}
                                            >
                                                <FaRegArrowAltCircleLeft className="mr-2" /> Retour à mon
                                                parcours
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Modal pour afficher les détails */}
             <Modal show={showModal} onHide={closeModal} size="lg">
                <Modal.Header>
                    <h3><span className="badge badge-default">{selectedEvaluation?.evaluation_id}</span></h3>
                </Modal.Header>
                <Modal.Body>
                    {selectedEvaluation && (
                        <ul className="p-0">
                            {selectedEvaluation.qcm.map((qcm, index) => (
                                <div
                                    key={qcm.id}
                                    style={{
                                        borderBottom: "1px solid #ccc",
                                        paddingBottom: "15px",
                                        marginBottom: "15px",
                                    }}
                                >
                                    <div>
                                        <span># {qcm.ref} - </span>
                                        <span
                                            id="question"
                                            style={{ fontSize: "13px" }}
                                            dangerouslySetInnerHTML={{
                                                __html: qcm.question,
                                            }}
                                        ></span>
                                    </div>

                                    {/* ====== AFFICHAGE SELON LE TYPE DE QUESTION ====== */}
                                    {qcm.type_question === 'correspondance' ? (
                                        renderCorrespondanceResultat(qcm)
                                    ) : (
                                        // ====== QUESTIONS CLASSIQUES (QCM standard) ======
                                        <>
                                            <div style={{ margin: "10px 10px" }}>
                                                {Object.keys(qcm)
                                                    .filter(
                                                        (key) =>
                                                            key.startsWith("option") &&
                                                            qcm[key] &&
                                                            (qcm[key] !== 'non défini' && qcm[key] !== 'vide')
                                                    )
                                                    .map((key, optionIndex) => {
                                                        const optionLetter = String.fromCharCode(65 + optionIndex);
                                                        const optionText = qcm[key];
                                                        
                                                        // Pour les questions classiques, reponse est un tableau de lettres
                                                        const correctAnswers = Array.isArray(qcm.reponse) ? qcm.reponse : [];
                                                        const userAnswers = Array.isArray(qcm.resultat) ? qcm.resultat : [];
                                                        
                                                        const isCorrectAnswer = correctAnswers.includes(optionLetter);
                                                        const isUserAnswer = userAnswers.includes(optionLetter);

                                                        let bgColor = 'transparent';
                                                        if (isUserAnswer && isCorrectAnswer) {
                                                            bgColor = '#d4edda';
                                                        } else if (isUserAnswer && !isCorrectAnswer) {
                                                            bgColor = '#f8d7da';
                                                        } else if (!isUserAnswer && isCorrectAnswer) {
                                                            bgColor = '#e8f5e9';
                                                        }

                                                        return (
                                                            <div
                                                                key={key}
                                                                style={{
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    marginBottom: "8px",
                                                                    fontSize: "12px",
                                                                    padding: "5px 10px",
                                                                    borderRadius: "4px",
                                                                    backgroundColor: bgColor,
                                                                    border: isUserAnswer && isCorrectAnswer ? '1px solid #28a745' :
                                                                        isUserAnswer && !isCorrectAnswer ? '1px solid #dc3545' : '1px solid transparent'
                                                                }}
                                                            >
                                                                <span style={{ minWidth: '25px', fontWeight: 'bold' }}>
                                                                    {optionLetter} -
                                                                </span>
                                                                <span style={{ flex: 1 }}>
                                                                    {optionText}
                                                                </span>
                                                                {isCorrectAnswer && isUserAnswer ? (
                                                                    <i className="fa fa-check-circle" style={{ color: 'green', fontSize: '18px' }} title="Bonne réponse sélectionnée"></i>
                                                                ) : isCorrectAnswer ? (
                                                                    <i className="fa fa-circle-o" style={{ color: '#6c757d', fontSize: '16px' }} title="Bonne réponse non sélectionnée"></i>
                                                                ) : isUserAnswer ? (
                                                                    <i className="fa fa-times-circle" style={{ color: 'red', fontSize: '18px' }} title="Mauvaise réponse sélectionnée"></i>
                                                                ) : null}
                                                            </div>
                                                        );
                                                    })}
                                            </div>

                                            {/* VOTRE RÉPONSE AVEC BADGE */}
                                            <div style={{
                                                marginTop: '10px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '8px',
                                                flexWrap: 'wrap',
                                                justifyContent: 'space-between'
                                            }}>
                                                <span style={{ fontWeight: 'bold', fontSize: '13px' }}>
                                                    Votre réponse : <span style={{ fontSize: '13px' }}>
                                                        {(() => {
                                                            const userAnswers = Array.isArray(qcm.resultat) ? qcm.resultat : [];
                                                            return userAnswers.length > 0 ? userAnswers.join(', ') : 'Aucune réponse';
                                                        })()}
                                                    </span>
                                                </span>

                                                {(() => {
                                                    const userAnswers = Array.isArray(qcm.resultat) ? qcm.resultat : [];
                                                    const correctAnswers = Array.isArray(qcm.reponse) ? qcm.reponse : [];
                                                    const isCorrect = userAnswers.length > 0 &&
                                                        JSON.stringify([...userAnswers].sort()) === JSON.stringify([...correctAnswers].sort());
                                                    return (
                                                        <span style={{
                                                            padding: '2px 10px',
                                                            borderRadius: '4px',
                                                            fontWeight: 'bold',
                                                            fontSize: '12px',
                                                            backgroundColor: isCorrect ? '#28a745' : '#dc3545',
                                                            color: 'white',
                                                            display: 'inline-block',
                                                            marginLeft: '5px'
                                                        }}>
                                                            {isCorrect ? '✅ Correct' : '❌ Incorrect'}
                                                        </span>
                                                    );
                                                })()}
                                            </div>

                                            {/* BONNES RÉPONSES */}
                                            <div style={{ marginTop: '5px', fontStyle: 'italic', color: 'blue', fontSize: '13px' }}>
                                                <strong>Bonnes réponses :</strong> {qcm.reponse && Array.isArray(qcm.reponse) ? qcm.reponse.join(' , ') : 'Aucune'}
                                            </div>

                                            {/* EXPLICATION */}
                                            {qcm.explication && qcm.explication !== "non défini" && (
                                                <div style={{ color: "green", marginTop: '5px', fontSize: '13px' }}>
                                                    <strong>Explication :</strong>{' '}
                                                    <span
                                                        dangerouslySetInnerHTML={{
                                                            __html: qcm.explication,
                                                        }}
                                                    />
                                                </div>
                                            )}
                                        </>
                                    )}
                                </div>
                            ))}
                        </ul>
                    )}
                    <div className="text-right">
                        <Button variant="secondary" onClick={closeModal}>
                            Fermer
                        </Button>
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    );
};

export default Historique_evaluation;
